import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import api from '../services/api';
import { imageService } from '../services';

const PAGE_SIZE = 12;

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [size] = useState(PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/blogs/all?page=${page}&size=${size}`);
        setBlogs(res?.data?.content || res?.content || []);
        setTotalPages(res?.data?.totalPages || res?.totalPages || 1);
        setTotalElements(res?.data?.totalElements || res?.totalElements || 0);
      } catch (err) {
        setError('Failed to load blogs.');
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, [page, size]);

  useEffect(() => {
    document.title = 'Game Lim - Blog';
  }, []);

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setPage(i)}
          style={{
            margin: '0 4px',
            padding: '6px 14px',
            borderRadius: 6,
            border: i === page ? '2px solid #06beb6' : '1px solid #eee',
            background: i === page ? 'linear-gradient(90deg, #06beb6 0%, #fa709a 100%)' : '#fff',
            color: i === page ? '#fff' : '#222',
            fontWeight: 700,
            cursor: 'pointer',
            transition: 'all 0.18s',
          }}
          disabled={i === page}
        >
          {i}
        </button>
      );
    }
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 32, gap: 8 }}>
        <button
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
          style={{ marginRight: 8, padding: '6px 14px', borderRadius: 6, border: '1px solid #eee', background: '#fff', color: '#222', cursor: page === 1 ? 'not-allowed' : 'pointer' }}
        >Prev</button>
        {pages}
        <button
          onClick={() => setPage(page + 1)}
          disabled={page === totalPages}
          style={{ marginLeft: 8, padding: '6px 14px', borderRadius: 6, border: '1px solid #eee', background: '#fff', color: '#222', cursor: page === totalPages ? 'not-allowed' : 'pointer' }}
        >Next</button>
      </div>
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
      <Header />
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 16px' }}>
        <h1 style={{ fontSize: 32, fontWeight: 700, marginBottom: 32, textAlign: 'left' }}>Discover Our Blog</h1>
        {loading && <div>Loading...</div>}
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
          gap: 28,
        }}>
          {blogs.map((item, idx) => (
            <div
              key={item.id || idx}
              style={{
                background: '#fff',
                borderRadius: 16,
                boxShadow: '0 4px 16px rgba(0,0,0,0.07)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 320,
                position: 'relative',
                transition: 'box-shadow 0.2s',
                cursor: 'pointer',
              }}
              onClick={() => navigate(`/blog/${item.slug}`)}
            >
              <div style={{ position: 'relative' }}>
                {item.categoryName && (
                  <div style={{
                    position: 'absolute',
                    top: 14,
                    left: 14,
                    background: '#10a6c7',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: 15,
                    borderRadius: 7,
                    padding: '4px 16px 4px 12px',
                    zIndex: 2,
                    letterSpacing: 1,
                    boxShadow: '0 2px 8px rgba(16,166,199,0.10)',
                  }}>{item.categoryName}</div>
                )}
                <img
                  src={item.thumbnailPath ? imageService.getThumbnail(item.thumbnailPath) : (item.image || 'https://via.placeholder.com/400x220?text=No+Image')}
                  alt={item.title}
                  style={{ width: '100%', height: 180, objectFit: 'cover', background: '#eee', borderTopLeftRadius: 16, borderTopRightRadius: 16 }}
                />
              </div>
              <div style={{ padding: 20, flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ color: '#888', fontSize: 14, marginBottom: 8, textAlign: 'left' }}>{item.createDate ? formatDate(item.createDate) : ''}</div>
                <h2 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 10px 0', color: '#222', textAlign: 'left', lineHeight: 1.3 }}>{item.title}</h2>
                <div style={{ color: '#666', fontSize: 15, marginBottom: 0, textAlign: 'left', flex: 1 }}>{item.description || item.shortDescription || ''}</div>
              </div>
            </div>
          ))}
        </div>
        {renderPagination()}
        <div style={{ marginTop: 18, color: '#888', fontSize: 15, textAlign: 'right' }}>
          Total: {totalElements} blogs
        </div>
      </div>
    </>
  );
};

export default Blogs; 